<!--统计下级代理商的用户某个时间段切割数量-->
<template>
    <viewTable
        ref="viewTableRef"
    />
</template>

<script>
import viewTable from "../AgentStatistics/template/viewTable";
export default {
    name: "cut",
    components:{
        viewTable
    },
    data(){
        return {
            lang:this.$lang.getLang('userStatistics','KeyByRec'),
        }
    },
    methods:{

    },
    mounted() {
        // this.$refs.viewTableRef.explain = '用于统计自己旗下的用户某个时间段所使用的充值码金额';
        this.$refs.viewTableRef.explain = this.lang['explain'];
        //[默认]设置成不统计下级
        this.$refs.viewTableRef.isType = false;
        this.$refs.viewTableRef.postData.type = 2;
        this.$refs.viewTableRef.init('UserReport.report/getKeyUseByRec');
    }
}
</script>

<style scoped>

</style>